/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconArrowsHorizontal = createReactComponent("outline", "arrows-horizontal", "IconArrowsHorizontal", [["path", { "d": "M7 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M17 8l4 4l-4 4", "key": "svg-1" }], ["path", { "d": "M3 12l18 0", "key": "svg-2" }]]);

export { IconArrowsHorizontal as default };
//# sourceMappingURL=IconArrowsHorizontal.mjs.map
